module.exports = __webpack_public_path__ + "static/media/internal_pages_campaigns.fd116992.png";